import { io, type Socket } from "socket.io-client";

export type ResilienceLiveStats = {
  testsStarted: number;
  testsCompleted: number;
  completionRatio: number;
  scoreDistribution: { scorePercent: number; count: number; label: string }[];
};

/**
 * Socket.IO server URL and path. When `VITE_API_BASE` ends with `/api`, the
 * engine path is `/api/socket.io` (same host as the site, nginx → API).
 */
export function getLiveSocketConfig(): { url: string; path: string } {
  const base = import.meta.env.VITE_API_BASE ?? "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  if (!base) {
    return { url: origin, path: "/socket.io" };
  }

  const trimmed = base.replace(/\/$/, "");
  if (trimmed.endsWith("/api")) {
    const root = trimmed.slice(0, -4) || origin;
    return { url: root, path: "/api/socket.io" };
  }

  return { url: trimmed, path: "/socket.io" };
}

export function createLivePresentationSocket(): Socket {
  const { url, path } = getLiveSocketConfig();
  return io(`${url.replace(/\/$/, "")}/live-presentation`, {
    path,
    transports: ["websocket", "polling"],
    autoConnect: true,
  });
}
